<template>
    <ElCheckbox
        class="patsnap-biz-email_alert__checkbox"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot />
    </ElCheckbox>
</template>

<script>
import Checkbox from 'element-ui/lib/checkbox';

export default {
    name: 'Checkbox',
    components: {
        ElCheckbox: Checkbox,
    },
};
</script>
